/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export enum AuthActions {
  LOGIN = '[Auth] Login',
  SET_ERROR = '[Auth] Set Error',
  LOGOUT = '[Auth] Logout',
  FORGOT = '[Auth] Forgot',
}
